export default ($axios) => ({
    getDeliveryData() {
        return $axios({
            method: 'GET',
            url: '/settings/delivery_page',
        })
    },
    getDeliveryCompanies() {
        return $axios({
            method: 'GET',
            url: '/base/delivery-services',
        })
    },
    postDeliveryCost(data) {
        return $axios({
            method: 'POST',
            url: '/general/delivery-cost/',
            data: data
        })
    },
})